import React, {useState,useEffect} from "react";
import Header from "../layouts/Header";
import Footer from "../layouts/Footer";
import ScrollPageTop from '../routes/ScrollPageTop'
import Seo from '../components/seo/seo'
import {PlainIcon} from '../custom-icons'
import {Links} from '../routes/PathLink'
import SelectInput from '../ui/select-input.jsx'
import Label from '../ui/label.tsx'
import LeftMenuLayout from '../layouts/LeftMenuLayout';


import {
   APP_URL, 
   APP_NAME, 
   API_ENDPOINT, 
   toast_anim_error, 
   toast_anim,
   consultation_for,
   date_format
} from '../components/config/Common'

import Input from '../ui/input.jsx'
import PhoneInput from 'react-phone-input-2'
import 'react-phone-input-2/lib/bootstrap.css'
import Button from '../ui/Button.tsx'
import TextArea from '../ui/text-area.tsx'
import classNames from 'classnames';
import * as Yup from 'yup';
import { toast } from 'react-toastify';

import {
   useForm,
   Controller
 } from 'react-hook-form';
 
import { yupResolver } from '@hookform/resolvers/yup';


import axios from 'axios';  

const FormSchema = Yup.object().shape({
   name: Yup.string()
      .required('You must need to provide full name.')
      .min(2, 'Name is too short!')
      .max(50, 'Name is too long!'),
   phone_no: Yup.string()
      .required('You must need to provide phone number.')
      .min(12, 'Invalid phone number.'),
   email: Yup.string()
      .required('You must need to provide email address.')
      .email('Invalid email.'),
   subject: Yup.string()
      .required('You must need to provide Subject.'),
   message: Yup.string()
      .required('Tell us about Your requirements for imaging equipment.'),
  /* consultation_for_id:Yup.object()
      .nullable()
      .required('Consultation For is required.'),
   consultation_for_label:Yup.string().when('consultation_for_id', {
      is: (consultation_for_id) => consultation_for_id?.id == 'Other',//just an e.g. you can return a function
      then: Yup.string().required('Consultation For is required'),
      otherwise:Yup.string(),
   }),
   */
});

let defaultValues = {  
   name: '',
   email:'',
   phone_no:'',
   subject:'',
   message:''
};




const RequestEquipment = () => {
   const [loading, setLoading] = useState(false)
   const [success, setSuccess] = useState(false)
   const [pagecontent, setPagecontent] = useState(null);
   const [pagetitle, setPageTitle] = useState(null);

   const [access_token, setAccess_token] = useState(localStorage.getItem('access_token'))
   const [user_type, setUser_type] = useState(localStorage.getItem('user_type'))
   const [user_me, setUser_me] = useState(null);
   const [imaging_equipment_list, setImaging_equipment_list] = useState([]);
   const [isFetch, setIsFetch] = useState(false);

   const [consultation_for_id , setConsultationForId] = useState('');
   const { register, handleSubmit , reset, control, setValue, setError, formState: { errors },} = useForm({
      defaultValues: defaultValues,
      resolver: yupResolver(FormSchema),
   });
   

   useEffect(() => {
      getMyProfile()
   },[]);

   useEffect(() => {
      imaging_equipment_listing()
   },[isFetch]);

   const getMyProfile = () => {
         //console.log(this.state.access_token)
         fetch(`${API_ENDPOINT}/user_me`,{
            method: 'GET',
            headers : {        
               'Content-Type': 'application/json',
               'Accept': 'application/json',
               'Authorization': 'Bearer '+access_token, 
            }
         }).then(function (response) {
               return response.json();
         }).then( (result)=> {
            console.log('result=====', result)
            setUser_me(result.data)
            let data = result.data
            defaultValues = {  
               name: data.name,
               email:data.email,
               phone_no:data.phone_no,
            };
            reset(defaultValues)
            //getCitiesByState(data.state_id)
         })
      }	

   const imaging_equipment_listing = () => {
        
        axios.get(`${API_ENDPOINT}/imaging_equipment_listing`, {
            headers : {        
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': 'Bearer '+access_token, 
            }
        }).then(function (response) {
            setImaging_equipment_list(response.data.data)
        });
   }   


    const handleSelect = (val,name) => {  
      console.log('dropdown val======',val,name.name);
       if(name.name === 'consultation_for_id'){
         
         setValue('consultation_for_id', val, true);
         setConsultationForId(val?.id);
      }
   }

     

   const onSubmit = (values) => {
      //console.log('job form======',values)
      setLoading(true)
      setIsFetch(false)
      let input = values;
      
      //console.log('job form======',input)
      
      axios.post(`${API_ENDPOINT}/request_imaging_equipment`,input,{
         headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'Authorization': 'Bearer '+access_token, 
         }
      }).then( (result)=> {
         //console.log('data=====',result.data)
         setLoading(false)
         if(result.data.status == 1){
            toast_anim('Application submitted')
            //reset(values);
            setSuccess(true)
            setIsFetch(true)
            window.scrollTo({
               top: 0,
               left: 0,
               behavior: "smooth"
             });
         }else{
            toast_anim_error('Error in submit')
         }
      })
   }

   return(
      <ScrollPageTop>
         <Seo 
            title={`Requirements for imaging equipment - ${APP_NAME}`}
            desc="Requirements for imaging equipment"
            url={`${APP_URL}${Links.REQUEST_EQUIPMENT}`}
            image={`./img/home-bg.jpg`}
         />

        <LeftMenuLayout>
            <div className="w-full">
               <div className={classNames('w-full p-5 md:p-8 bg-light shadow rounded mb-8 ')}>
                  <h1 className="mb-7 font-body text-xl font-bold text-heading md:text-2xl">
                  Post your requirements for imaging equipment.
                  </h1>
                  {
                  success ?
                  <p className="my-2 text-xl text-center text-green-500">
                     Your requirements has been submitted successfully.<br/>We will be get back to you soon.
                  </p>
                  :
                  <form onSubmit={handleSubmit(onSubmit)}>
                     
                     <div className="grid grid-cols-1 gap-2 sm:gap-6 sm:grid-cols-2">
                        <Input                
                           label={`Name`}
                           {...register('name')}
                           variant="outline"
                           className="mb-5"
                           error={errors.name?.message}
                           required
                        />
                        <Input                
                           label={`Email`}
                           {...register('email')}
                           variant="outline"
                           className="mb-5"
                           type="email"
                           error={errors.email?.message}
                           required
                        />
                     </div>
                     <div className="grid grid-cols-1 gap-2 sm:gap-6 sm:grid-cols-2">
                        
                     
                        <div className="mb-5">
                           <label htmlFor="phone_no" className="block mb-3 text-sm font-semibold leading-none text-body-dark">Phone number <span className="text-red-500">*</span></label>
                           <Controller
                              name="phone_no"
                              control={control}
                              render={({ field }) => (
                                 <PhoneInput
                                    country="in"
                                    disableDropdown
                                    countryCodeEditable={false}
                                    inputClass="!p-0 ltr:!pr-4 rtl:!pl-4 ltr:!pl-14 rtl:!pr-14 !flex !items-center !w-full !appearance-none !transition !duration-300 !ease-in-out !text-heading !text-sm focus:!outline-none focus:!ring-0 !border !border-border-base !rounded focus:!border-accent !h-12"
                                    dropdownClass="focus:!ring-0 !border !border-border-base !shadow-350"
                                    {...field}
                                 />
                              )}
                           />
                           <p className="my-2 text-xs text-start text-red-500">{errors.phone_no?.message}</p>
                        </div>
                        <Input                
                           label={`Subject`}
                           {...register('subject')}
                           variant="outline"
                           className="mb-5"
                           error={errors.subject?.message}
                           required
                        />
                     </div>

                     <TextArea
                        label='POST YOUR REQUIREMENT'
                        {...register('message')}                        
                        variant="outline"
                        className="mb-5"
                        error={errors.message?.message}
                        required
                     />
                     
                     
                     
                     <Button loading={loading}>
                        Submit <PlainIcon className="ml-2" />
                     </Button>
                  </form>
                  }
               </div>
               <div className={classNames('w-full p-5 md:p-8 bg-light dark:bg-gray-700 shadow rounded mb-8')}>
                  <p className="text-lg lg:text-xl text-heading capitalize mb-5 dark:text-zinc-400">Your Previous Requirements</p>
                  <table className="table-auto w-full text-left border">
                     <thead className="bg-gray-300">
                           <tr>
                              <th className="border px-4 py-2">Subject</th>
                              <th className="border px-4 py-2">Requirements</th>
                              <th className="border px-4 py-2">Date</th>
                           </tr>
                     </thead>
                     <tbody>
                           {imaging_equipment_list && imaging_equipment_list.length > 0 && imaging_equipment_list.map((item, index) => (
                              <tr key={index}>
                                 <td className="border px-4 py-2">{item.subject}</td>
                                 <td className="border px-4 py-2">
                                       
                                       <div style={{ whiteSpace: "pre-line" }}>
                                       {item.message}
                                       </div>
                                 </td>
                                 <td className="border px-4 py-2">{date_format(item.created_at)}</td>
                              </tr>
                           ))}
                     </tbody>
                  </table>
               </div>
            </div>
         </LeftMenuLayout>
      </ScrollPageTop>
   )
}

export default RequestEquipment